module.exports = __webpack_public_path__ + "static/media/icons.211af25b.svg";